/*
* <license header>
*/

module.exports = {
  extensionId: 'demo-pilot'
}